import * as React from 'react';

export const QuoteIdContext = React.createContext<{quoteId?: string}>({quoteId: undefined});

export const useQuoteId = () => {
  const {quoteId} = React.useContext(QuoteIdContext)

  if (!quoteId) {
    console.warn('useQuoteId must be used within QuoteIdContext context and be defined')
  }

  return quoteId;
};
